import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useBrandContext } from '../../context/brand';

// The browser tab title is brand-static - it never varies by page. It reflects only which
// product this OEM brand is sold as, not which page/product area is currently being viewed.
export const BrandTitle = () => {
  const { isPanasonic } = useBrandContext();

  return (
    <Helmet>
      <title>{isPanasonic ? 'Smart Essentials' : 'Elemez'}</title>
    </Helmet>
  );
};
